import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'

Vue.use(Vuex)

const token = localStorage.getItem('token');
const initialState = token
    ?  'success'
    :  '' ;
 
function componentsToTree (parentId, components, list) {
  let i=0
  for (let k of components) {
    let children = []

    if (k.components && k.components.length > 0) {
      componentsToTree(parentId+"/"+k._id, k.components, children)
    }
    i++
    list.push( { id: parentId+"/"+k._id, name: k.name.de, children: children, cid: k._id, tasks: k.tasks } )

  
  }

  return list
}


export default new Vuex.Store({
  state: {
    key_shift: false, 
    status: initialState,
    user_role: null, 
    overview_loaded: false,
    rooms: [],
    token: localStorage.getItem('token') || '',
    realestate_results: [],
    headerTitle: "8.2 Inspect Tools", 
    saving: false, 
    saving_type: "", 
    checklists: null, 
    user : {},
    userId: null,
    machines: [],
    projects: [],
    inspection_types: [],
    users: {}, 
    message_formats: [], 
    pasteEntryOptionVal: null, 
    cl_message_formats: [], 
    checklist: {}, 
    //socket: null, 
    initParams: {}, 
    cl_uid: null, 
    cl_components: [],
    cl_components_2: [],
    cl_components_3: [],
    cl_components_4: [],
    cl_components_5: [],
    cl_components_6: [],
    cl_tasks: [],
    cl_component_uid: null, 
    cl_component: {},
    cl_component_level: 1, 
    cl_task_list: [],
    cl_task: {},
    cl_question_list: [],
    cl_question: {},
    cl_answer_list: [],
    cl_task_uid: null, 
    cl_question_uid: null, 
    cl_component_map: {},
    machine_filter: "", 
    machines_group_list: [], 
    cl_machine_groups: [],
    copy_entry: null,
    copy_blades_entry: {},
    search_drawer: false,
    searchField: false,
    select_machine_group: "public", 
    //---------------------
    che_inspections: [],     // Inspektionen
    che_inspection: {} ,      // Aktuelle Inspektion
    che_projectId: '19911331',
    che_comp: "",
    che_same_inspections: [], 
    che_results: [],
    company_id: null, 
    //------
    insp_inspections: [],
    pouch_db: {},
    lang: 'de-DE'
    //entry_machines: [],
  },
  getters : {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    userRole: state => {
      if (state.user_role) {
        return state.user_role
      }

      if (localStorage.getItem('user_role')) {
        let role = localStorage.getItem('user_role')
        if (role) {
          try {
            return JSON.parse(role)
          }
          catch (e) {

          }
        } 
      }
    },
    companyId: state => {
      if (state.company_id) {
        return state.company_id
      }

      if (localStorage.getItem('company_id')) {
        return  localStorage.getItem('company_id')
      }
    },
    allComponents: state => {
      let m = []
      for (let k of state.cl_components) {
        m.push({ text: k.name, value: k._id })
      }
      return m
    },
    inspectionComponents: state => {
      let m = []
      if (state.che_inspection && state.che_inspection["components"]) {
        let i=0
        for (let k of state.che_inspection["components"]) {
          let children = []
          if (k.components && k.components.length > 0) {
            componentsToTree(k._id, k.components, children)
          }
          i++
          m.push( { id: k._id, name: k.name.de, children: children, cid: k._id, tasks: k.tasks } )
        }
      }

      return m
    }
  },
  mutations: {
    update_results(state, payload){
      let nlist = []
      let found = false
      for (let k of state.che_results) {
        if (k._id == payload._id) {
          nlist.push({...payload})
          found = true
        }
        else {
          nlist.push(k)
        }
      }

      if (!found) {
        nlist.push({...payload})
      }

      Vue.set(state, 'che_results', [...nlist]);
    },
    select_comp(state, payload){
      state.cl_component_map[payload.level] = payload.uid
      for (let i = payload.level+1 ; i < 7 ; i++) {
        state.cl_component_map[i] = null 
      }
    },
    set_selected_route(state){
      router.push({ name: 'checklist', params: { comp: state.cl_component_map[1], 
                                                       comp2: (state.cl_component_map[2]) ? state.cl_component_map[2] : "c2",
                                                       comp3: (state.cl_component_map[3]) ? state.cl_component_map[3] : "c3",
                                                       comp4: (state.cl_component_map[4]) ? state.cl_component_map[4] : "c4",
                                                       comp5: (state.cl_component_map[5]) ? state.cl_component_map[5] : "c5",
                                                       comp6: (state.cl_component_map[6]) ? state.cl_component_map[6] : "c6",
                                                       task: (state.cl_task_uid) ? state.cl_task_uid : "t",
                                                       question: (state.cl_question_uid) ? state.cl_question_uid : "q" } }).catch(err => {})
    },
    set_inspection_url(state, payload) {
     console.log(state.initParams, payload, 'inspection')
     if  (state.initParams["comp"] != payload.comp || state.initParams["task"] != payload.task) {
        router.push({ name: 'inspection', params: {  
          comp: payload.comp,
          task: payload.task
        } }).catch(err => {})
     }
    },
    auth_request(state){
      state.status = 'loading'
    },
    auth_success(state, payload) {
      state.status = 'success'
      state.token = payload.token
      state.user = payload.user
    },
    auth_error(state){
      state.status = 'error'
    },
    logout(state){
      localStorage.removeItem('token')
      state.status = ''
      state.token = ''
    },
    cl_components(state, payload){
      state.cl_components = payload
    }
  },
  actions: {
    api_error ({ commit, state }, error) {
      console.log("api_error", error)
      commit('logout')
      router.push({ name: 'logout' })
    },
    //socket_connect({ commit, state }, error) {

    //}
  }
})
